/**
 * Minimal ZIP writer (STORE, no compression) for the workpaper export
 * (V98-6-8). Pure; no dependencies. Paths are forward-slash, UTF-8 (flag
 * bit 11). Deterministic for a given file list and timestamp.
 */
const CRC_TABLE = (() => {
    const t = new Uint32Array(256);
    for (let n = 0; n < 256; n++) {
        let c = n;
        for (let k = 0; k < 8; k++)
            c = c & 1 ? 0xedb88320 ^ (c >>> 1) : c >>> 1;
        t[n] = c >>> 0;
    }
    return t;
})();
export function crc32(data) {
    let c = 0xffffffff;
    for (let i = 0; i < data.length; i++)
        c = CRC_TABLE[(c ^ data[i]) & 0xff] ^ (c >>> 8);
    return (c ^ 0xffffffff) >>> 0;
}
function dosTime(d) {
    return {
        time: ((d.getUTCHours() & 31) << 11) | ((d.getUTCMinutes() & 63) << 5) | (Math.floor(d.getUTCSeconds() / 2) & 31),
        date: (((d.getUTCFullYear() - 1980) & 127) << 9) | (((d.getUTCMonth() + 1) & 15) << 5) | (d.getUTCDate() & 31),
    };
}
export function buildStoreZip(entries, at = new Date()) {
    const enc = new TextEncoder();
    const { time, date } = dosTime(at);
    const locals = [];
    const centrals = [];
    let offset = 0;
    for (const e of entries) {
        if (!e.path || e.path.startsWith('/') || e.path.includes('..'))
            throw new Error(`Unsafe zip path: ${e.path}`);
        const name = enc.encode(e.path);
        const crc = crc32(e.data);
        const local = new Uint8Array(30 + name.length);
        const lv = new DataView(local.buffer);
        lv.setUint32(0, 0x04034b50, true);
        lv.setUint16(4, 20, true);
        lv.setUint16(6, 0x0800, true);
        lv.setUint16(8, 0, true);
        lv.setUint16(10, time, true);
        lv.setUint16(12, date, true);
        lv.setUint32(14, crc, true);
        lv.setUint32(18, e.data.length, true);
        lv.setUint32(22, e.data.length, true);
        lv.setUint16(26, name.length, true);
        lv.setUint16(28, 0, true);
        local.set(name, 30);
        const central = new Uint8Array(46 + name.length);
        const cv = new DataView(central.buffer);
        cv.setUint32(0, 0x02014b50, true);
        cv.setUint16(4, 20, true);
        cv.setUint16(6, 20, true);
        cv.setUint16(8, 0x0800, true);
        cv.setUint16(10, 0, true);
        cv.setUint16(12, time, true);
        cv.setUint16(14, date, true);
        cv.setUint32(16, crc, true);
        cv.setUint32(20, e.data.length, true);
        cv.setUint32(24, e.data.length, true);
        cv.setUint16(28, name.length, true);
        cv.setUint32(42, offset, true);
        central.set(name, 46);
        locals.push(local, e.data);
        centrals.push(central);
        offset += local.length + e.data.length;
    }
    const centralSize = centrals.reduce((n, c) => n + c.length, 0);
    const end = new Uint8Array(22);
    const ev = new DataView(end.buffer);
    ev.setUint32(0, 0x06054b50, true);
    ev.setUint16(8, entries.length, true);
    ev.setUint16(10, entries.length, true);
    ev.setUint32(12, centralSize, true);
    ev.setUint32(16, offset, true);
    const out = new Uint8Array(offset + centralSize + 22);
    let p = 0;
    for (const part of [...locals, ...centrals, end]) {
        out.set(part, p);
        p += part.length;
    }
    return out;
}
/** Read a STORE zip back (used by tests and re-verification). */
export function readStoreZip(zip) {
    const v = new DataView(zip.buffer, zip.byteOffset, zip.byteLength);
    let eocd = -1;
    for (let i = zip.length - 22; i >= 0; i--)
        if (v.getUint32(i, true) === 0x06054b50) {
            eocd = i;
            break;
        }
    if (eocd < 0)
        throw new Error('Not a zip');
    const count = v.getUint16(eocd + 10, true);
    let p = v.getUint32(eocd + 16, true);
    const dec = new TextDecoder();
    const out = [];
    for (let n = 0; n < count; n++) {
        const nameLen = v.getUint16(p + 28, true);
        const size = v.getUint32(p + 24, true);
        const localOff = v.getUint32(p + 42, true);
        const path = dec.decode(zip.subarray(p + 46, p + 46 + nameLen));
        const lnameLen = v.getUint16(localOff + 26, true);
        const start = localOff + 30 + lnameLen;
        out.push({ path, data: zip.slice(start, start + size) });
        p += 46 + nameLen + v.getUint16(p + 30, true) + v.getUint16(p + 32, true);
    }
    return out;
}
//# sourceMappingURL=zip-store.js.map